import { computeBalanceDeviceDays, parseFiniteCreditNumber } from './computeBalanceDeviceDays';

export const MIGRATED_MUB_TYPES = Object.freeze({
  PREMIUM: 'PREMIUM',
  PRO: 'PRO'
});

/**
 * Normalizes migration type from API payload.
 * @param {unknown} migType
 * @returns {string}
 */
export function normalizeMigType(migType) {
  return typeof migType === 'string' ? migType.trim().toUpperCase() : '';
}

/**
 * Resolves whether the Premium/Pro MUB migration banner should be shown.
 *
 * @param {Object} params
 * @param {unknown} params.migType
 * @param {unknown} params.deviceCredits
 * @param {unknown} params.allocCredit
 * @param {unknown} params.mubUsage
 * @returns {{ visible: boolean, migType: string, balanceDeviceDays: number|null }}
 */
export function resolveMigratedMubBannerState({ migType, deviceCredits, allocCredit, mubUsage }) {
  const normalizedMigType = normalizeMigType(migType);

  if (normalizedMigType !== MIGRATED_MUB_TYPES.PREMIUM && normalizedMigType !== MIGRATED_MUB_TYPES.PRO) {
    return { visible: false, migType: normalizedMigType, balanceDeviceDays: null };
  }

  const credits = parseFiniteCreditNumber(deviceCredits);
  if (credits === null || credits <= 0) {
    return { visible: false, migType: normalizedMigType, balanceDeviceDays: null };
  }

  const balanceDeviceDays = computeBalanceDeviceDays(allocCredit, mubUsage);
  if (balanceDeviceDays === null || balanceDeviceDays <= 0) {
    return { visible: false, migType: normalizedMigType, balanceDeviceDays };
  }

  return { visible: true, migType: normalizedMigType, balanceDeviceDays };
}
